<div
  class="date-picker-field"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
>
  <label
    class="date-picker-label field-label"
    [attr.type]="'date-picker'"
    [attr.for]="fieldId"
    [ngClass]="{ disabled: formControl?.disabled }"
    type="text"
  >
    {{ label }}
  </label>

  <div class="date-picker-wrapper">
    <input
      class="date-picker-input"
      focusable
      tabindex="0"
      type="text"
      [placeholder]="allowEmptyDate ? placeholder : null"
      [attr.id]="fieldId"
      [attr.data-e2e-id]="e2eId"
      [attr.disabled]="formControl?.disabled ? 'disabled' : null"
      [datePicker]="datePickerContainer"
      [initialDate]="initialDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [allowEmptyDate]="allowEmptyDate"
      autocomplete="off"
      [value]="dateValue"
      (onDateSelect)="propagateChange($event)"
    />

    <div
      #datePickerContainer
      class="date-picker-container"
      [attr.data-h-alignment]="hAlignment"
      [attr.data-v-alignment]="vAlignment"
    ></div>
  </div>
</div>
